import React from "react";
import { observer } from "mobx-react";
import { PlatformLinkTypeUpdateStore } from "../../store";
import { PlatformLinkTypeUpdateForm } from "./PlatformLinkTypeUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type PlatformLinkTypeUpdateProps = {
  platformLinkTypeUpdateStore: PlatformLinkTypeUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const PlatformLinkTypeUpdate: React.FC<PlatformLinkTypeUpdateProps> =
  observer(
    ({ platformLinkTypeUpdateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={platformLinkTypeUpdateStore.isSaving} />
          <OutdatedAfterSaveNotice
            open={platformLinkTypeUpdateStore.savedButOutdated}
            onReload={() =>
              platformLinkTypeUpdateStore.reloadPlatformLinkType()
            }
            reloadDisabled={platformLinkTypeUpdateStore.isProcessing}
          />
          <PlatformLinkTypeUpdateForm
            platformLinkTypeUpdateStore={platformLinkTypeUpdateStore}
            nameError={platformLinkTypeUpdateStore.errors.name?.message}
            onNameChange={(value: string) => {
              platformLinkTypeUpdateStore.setNameValue(value);
            }}
            name={platformLinkTypeUpdateStore.entityValues.name}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={platformLinkTypeUpdateStore.saveDisabled}
            onSave={() => platformLinkTypeUpdateStore.savePlatformLinkType()}
            onCancel={() =>
              platformLinkTypeUpdateStore.cancelPlatformLinkType()
            }
          />
          <ErrorDialog
            open={platformLinkTypeUpdateStore.errorDialogOpened}
            title={platformLinkTypeUpdateStore.errorTitle}
            description={platformLinkTypeUpdateStore.errorDescription}
            onClose={() => platformLinkTypeUpdateStore.closeErrorDialog()}
          />
          <ConfirmCancelDialog
            open={platformLinkTypeUpdateStore.confirmDialogOpened}
            title={platformLinkTypeUpdateStore.confirmDialogTitle}
            description={platformLinkTypeUpdateStore.confirmDialogDescription}
            onConfirm={() =>
              platformLinkTypeUpdateStore.executeConfirmedAction()
            }
            onCancel={() => platformLinkTypeUpdateStore.closeConfirmDialog()}
          />
        </>
      );
    }
  );
